"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const generic_1 = __importDefault(require("./generic"));
const netlifySiteId = process.env.SITE_ID;
const netlifyBuildId = process.env.BUILD_ID;
const netlifyContext = process.env.CONTEXT;
const netlifyDeploymentUrl = process.env.DEPLOYMENT_URL;
const netlifyDeploymentId = process.env.DEPLOYMENT_ID;
class NetlifyConfig extends generic_1.default {
    wrapWebVitalsObject(metrics) {
        return metrics.map(m => ({
            webVital: m,
            _time: new Date().getTime(),
            netlify: {
                environment: this.environment,
                source: 'web-vital',
                siteId: netlifySiteId,
                buildId: netlifyBuildId,
                context: netlifyContext,
                deploymentUrl: netlifyDeploymentUrl,
                deploymentId: netlifyDeploymentId,
            },
        }));
    }
    injectPlatformMetadata(logEvent, source) {
        logEvent.netlify = {
            environment: this.environment,
            region: source === 'edge' ? process.env.DENO_REGION : process.env.AWS_REGION,
            source: source + '-log',
            siteId: netlifySiteId,
            buildId: netlifyBuildId,
            context: netlifyContext,
            deploymentUrl: netlifyDeploymentUrl,
            deploymentId: source === 'edge' ? process.env.DENO_DEPLOYMENT_ID : netlifyDeploymentId,
        };
    }
}
exports.default = NetlifyConfig;
//# sourceMappingURL=netlify.js.map